import { Injectable } from '@angular/core';
import { ApprovalsPageConnector } from './approvals-page.connector';
import { ReplyConfig } from './approvals-page.model';

@Injectable({
  providedIn: 'root',
})
export class ApprovalsPageService {
  constructor(private approvalsPageConnector: ApprovalsPageConnector) {}

  getRequestList() {
    return this.approvalsPageConnector.getRequestList();
  }

  getRequestDetails(codeRequest: string) {
    return this.approvalsPageConnector.getRequestDetails(codeRequest);
  }

  replyRequest(replyConfig: ReplyConfig) {
    return this.approvalsPageConnector.replyRequest(replyConfig);
  }
}
